export const lineHeight = {
    lH16: '16px'
  };
  